import React from "react";

const Footer = () => {
  return (
    <div
      className="App bg-dark"
      style={{ backgroundColor: "", padding: "15px" }}
    >
      <a href="+880">
        <i style={{ color: "#ffa500" }} className="fas fs-4 ms-5 fa-phone"></i>
      </a>
      <a href="https://www.linkedin.com/in/ronymiah/">
        <i style={{ color: "#ffa500" }} className="fab fs-4 ms-5 fa-linkedin-in"></i>
      </a>
      <a href="https://github.com/RonyMiah">
        <i style={{ color: "#ffa500" }} className="fab fs-4 ms-5 fa-github"></i>
      </a>
      <br />
      <p className="text-white">© 2021 Rony Miah (Junior Web developer) </p>
    </div>
  );
};

export default Footer;
